import { GlassCard } from "@/components/glass-card"

interface MotivationSectionProps {
  title: string
  description: string
  amount: string
}

export function MotivationSection({ title, description, amount }: MotivationSectionProps) {
  return (
    <section className="py-12 md:py-24">
      <div className="container mx-auto px-4">
        <GlassCard className="max-w-3xl mx-auto p-8 md:p-12 text-center">
          <div className="space-y-6">
            <div className="text-6xl md:text-7xl font-bold">{amount}</div>
            <h2 className="text-2xl md:text-3xl font-bold">{title}</h2>
            <p className="text-lg text-muted-foreground leading-relaxed">{description}</p>
          </div>
        </GlassCard>
      </div>
    </section>
  )
}
